
import { LayoutCrearDoc } from "../../layouts";
import { useTodosCategorias } from "../../../hooks/cache";
import { useNavigate } from "react-router-dom";
import { CargandoMedio } from "../../components";
import { BuscadorXTermino } from "../../components/buscadores";
import { TablaListadoCategoria } from "../components/TablaListadoCategoria";




export const ListadoCategorias = () => {


    const navigate = useNavigate();
    const { data, isLoading,termino, chageTermino, chagePage, page } = useTodosCategorias();


    const handleNavegar = () => {
        navigate(`/super/crear-categoria`);
    }



    
    return (

        <LayoutCrearDoc titulo='Listado de Categorias' funcion={ handleNavegar }>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de categorias..." />
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="categoria" playhol="nombre o algo en común" />
                <TablaListadoCategoria data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>

    )
}
